export enum OdmaUrlType {
  MembershipRenewal = "MembershipRenewal",
  DigitalMembershipRegistration = "DigitalMembershipRegistration",
  DigitalMembershipRedemption = "DigitalMembershipRedemption",
  LandingPage = "LandingPage",
  MemberSelfService = "MemberSelfService",
}
